
import { Vue, Component, Prop } from 'vue-property-decorator';
import Model from './model';
import MenuComponents from '@/components/menu.vue';
import PageComponents from '@/components/page.vue';
import Common from "../../commonUtil/common";


// 必须使用@Component注解
@Component({
  components: {
    MenuComponents,
    PageComponents,
  },
})
export default class PersonValVue extends Vue {
  private model = new Model();
  private common = new Common();

  private form: any = {
    title: '',
    name: '',
    id: ''
  }; 


  private tableData: any = null; 

  // 人物名称
  private personName: any = '';

  private data: any = '';

  // 新建窗口是否显示的标记
  private dialogFormVisible: boolean = false;

  // 所有下拉问题
  private questionOptions: any;
  
  // 分页插件用的属性
  private pageBean = {
    current: 1,
    size: 10,
    pages: 0, // 总页数
    total: 0, // 总记录条数
  };

  // 分页请求参数
  private pageParam = {
    data:{
      createUser: '',
      name: '',
    },
    pageBean: this.pageBean,
  };

   // 分页查询
  private async selectPageData() {
    if(!this.pageParam.data.createUser){
      const myuser: any = await this.common.getMyuser();
    this.pageParam.data.createUser = myuser.id;
    }
    
    const result = await this.model.selectPageData(this.pageParam);
    if ( result!=null ) {
      this.tableData = result.data.records;

       this.pageBean.pages = result.data.pages;
       this.pageBean.total = result.data.total;
    }
  }

    // 分页组件的值修改后，会调用该方法
  private async pageChange(data: any) {
    this.pageBean = data;
    this.selectPageData();
  }

  // 查找
  private async search(data: any) {
    this.pageBean.current = 1;
    this.selectPageData();
  }

    // 弹出新增框
  private async showNew() {
    const myuser: any = await this.common.getMyuser();
    this.form.title = '新增';
    this.form.id = '';
    this.form.name = '';
    this.dialogFormVisible = true;
  }

   // 弹出编辑框
  private async showUpdate(row: any) {
    let param = {
      data:{
        id: row.id,
      }
    };
    const result = await this.model.getById(param);
    this.form.title = '修改';
    this.form.id = row.id;
		this.form.name = result.data.name;
    this.dialogFormVisible = true;
  }

  
  // 跳转到详情页面
  private async goDetail(row : any) {
    let goParam =  {
      funId: row.id,
      name: row.name
    }
    this.$router.push({ path: "/funDetail", query: goParam });
  }

  // 跳转到详情数据页面
  private async goDetailData(row : any) {
    let goParam =  {
      funId: row.id,
      name: row.name
    }
    await this.$router.push({ path: "/funDetailData", query: goParam });
  }

  private async goDelete(row : any) {
    const flag = await Vue.prototype.$confirm('确定删除吗?');
    const id = row.id;
    if (flag) {
      let paramT = {
        data: {
          id: row.id
        }
      }
      debugger;
      const funDetailResult = await this.model.selectFunDetailDataCountByFunId(paramT);
      if(funDetailResult.data>0){
        Vue.prototype.$message.error('该功能存在明细数据,不能删除');
        return ;
      } 
      const param = {
        ids: id,
      };
      const result = await this.model.removeByIds(param);
      if (result) {
        Vue.prototype.$message.success('删除成功');
        // 重新计算当前页
        this.common.recalculateCurrent(this.pageBean);
        this.selectPageData();
      } else {
        Vue.prototype.$message.error('删除失败');
      }
    }
  }

 

  // 新建问题
  private async save() {
    // const myuser: any = localStorage.getItem("myuser");
    const myuser: any = await this.common.getMyuser();
    const param = {
      data:{
        createUser: myuser.id,
        updateUser: myuser.id,
        id: this.form.id,
        name: this.form.name,
      }
    }
    let result: any ;
    if (this.form.id) {
      result = await this.model.updateById(param);
    } else {
      result = await this.model.save(param);
    }
    if(result && result.code==200){
      Vue.prototype.$message.success('操作成功');
      this.dialogFormVisible = false;
      this.pageBean.current = 1;
      this.selectPageData();
    }
  }


  private async mounted() {
    
    const query: any = this.$route.query;
    if(query){
      this.pageParam.data.createUser = query.createUser;
    }
    await this.selectPageData();
  }
 
  // 跳转到上一页
  private async goHostory() {
    this.$router.go(-1);
  }

  
}
